<div
  #offcanvas
  class="offcanvas offcanvas-start now-slide-in"
  tabindex="-1"
  [attr.id]="'facetten-mobile'"
  aria-labelledby="'facetten-mobile-modal-title'"
>
  <div class="offcanvas-header">
    <h2 class="offcanvas-title h4" id="facetten-mobile-modal-title">Suche anpassen</h2>
    <button
      type="button"
      class="now-btn now-btn-tertiary now-btn-icon-only now-icon-x"
      data-bs-dismiss="offcanvas"
      aria-label="Modaldialog schließen"
      title="Modaldialog schließen"
    ></button>
  </div>
  <div class="offcanvas-body" id="facetten_slidein_body">
    <ng-content></ng-content>
  </div>
  <div class="now-slide-in-footer flex-small">
    <button
      class="now-btn now-btn-secondary now-btn-block w-auto m-0"
      type="button"
      (click)="resetAllFilters.emit()"
      id="button_filter_loeschen"
    >
      <span>Alle zurücksetzen</span>
    </button>
    <button
      class="now-btn now-btn-primary now-btn-block w-auto m-0"
      [ngClass]="loading ? 'now-btn-loading' : 'faded-out'"
      [disabled]="loading"
      type="button"
      aria-label="Zeige Suchergebnisse an"
      data-bs-toggle="offcanvas"
      data-bs-target="#facetten-mobile"
      id="button_zeige_suchergebnisse"
    >
      <span>Ergebnisse anzeigen</span>
    </button>
  </div>
</div>
